import React from 'react';

import {addons, types} from '@storybook/manager-api';

import Panel from './components/Panel';

const ADDON_ID = 'nfq-github-issues';
const PANEL_ID = `${ADDON_ID}/panel`;

addons.register(ADDON_ID, () => {
    addons.add(PANEL_ID, {
        render: ({active}) => (
            <Panel active={active} />
        ),
        title: 'Github',
        type: types.PANEL
    });
});